<template>
  <main class="main">
    <form class="form" @submit.prevent="createUpdateFabricant">
      <fieldset class="fieldset">
        <legend class="legend">
          <PhFactory />
          <span>Informations</span>
        </legend>

        <div class="field">
          <label class="label">Nom</label>
          <input type="text" class="input" v-model="fabricant.nom" required />
        </div>
      </fieldset>
      <div class="buttons">
        <ButtonElement
          type="submit"
          color="bordeaux"
          :icon="PhFloppyDisk"
          :disabled="!cacheStore.online"
        >
          {{ fabricantId ? 'Modifier' : 'Créer' }}
        </ButtonElement>
      </div>
    </form>
  </main>
</template>

<script setup lang="ts">
import { PhFactory, PhFloppyDisk } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import { computed, type ComputedRef, onMounted, ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useFetch from '@/composables/useFetch.ts'
import { useLoadingStore } from '@/stores/loading.ts'
import { useToastStore } from '@/stores/toast.ts'
import type { FabricantCreate, FabricantUpdate } from '@/interfaces/Fabricant.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()
const route = useRoute()
const router = useRouter()

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()
const toastStore = useToastStore()

// données
const fabricant: Ref<FabricantCreate | FabricantUpdate> = ref({
  id: '',
  nom: '',
})

// computed
const fabricantId: ComputedRef<string | undefined> = computed(() => route.params.id?.toString())

// fonctions
async function getFabricant() {
  if (fabricantId.value) fabricant.value = await cacheStore.getFabricant(fabricantId.value)
}

async function createUpdateFabricant() {
  loadingStore.start()
  try {
    if (fabricantId.value) {
      await api.put(`fabricants/${fabricantId.value}`, fabricant.value)
    } else {
      await api.post('fabricants/', fabricant.value)
    }
    toastStore.success(`Le fabricant a bien été ${fabricantId.value ? 'modifié' : 'créé'}.`)
    await router.push({ name: 'fabricants' })
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getFabricant()
  } finally {
    loadingStore.stop()
  }
})
</script>
